import angular from 'angular';
import User from '../user/';

import FinancingController from './financingController';
import TermSetController from './termSetDirective/termSetController';
import FinancingFactory from './financingFactory';
import termSetDirective from './termSetDirective/termSetDirective';
import FinancingTermsModalController from './financingTermsModal/financingTermsModalController';

import HPAppDetailTypes from '../../config/app.appDetail.config';
import FinancingConfig from '../../config/app.financing.config';

export default angular.module('app.accounts.financing', [User])
    .controller('FinancingController', FinancingController)
    .controller('FinancingTermsModalController', FinancingTermsModalController)
    .controller('TermSetController', TermSetController)
    .service('FinancingFactory', FinancingFactory)
    .constant('HPAppDetailTypes', HPAppDetailTypes)
    .constant('FinancingConfig', FinancingConfig)
    .directive('termSet', termSetDirective)
    .run(($templateCache) => {
        $templateCache.put('app/accounts/financing/financingTermSets.html', require('./financingTermSets.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/financing/financingTermsModal/confirmSelectedRates.html', require('./financingTermsModal/confirmSelectedRates.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/financing/financingTermsModal/financingTermsModal.html', require('./financingTermsModal/financingTermsModal.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/financing/financingTermsModal/selectedRatesConfirmed.html', require('./financingTermsModal/selectedRatesConfirmed.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/financing/financingTermsModal/viewAvailableRates.html', require('./financingTermsModal/viewAvailableRates.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/accounts/financing/index.js